// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cu6o","fullView":"styles_fullView__1zUfQ"};